import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, Link } from "react-router-dom";
import ReactGA from "react-ga4";
import Scroll from "react-scroll";
import Loader from "components/Loader";
import AlertModal from "../alert/AlertModal";
import ActivationModal from "./ActivationModal";
import {
	fetchPasswordReset,
	setPasswordErrorMsg,
} from "features/account/resetPasswordSlice";
import { USER_TYPE } from "features/constants";

import bgImage from "images/login-bg-ff.jpg";

const renderError = (error) => {
	if (error != null) {
		return <li>{error}</li>;
	}
	return null;
};

const scroll = Scroll.animateScroll;

export default function ResetPassword(props) {
	const dispatch = useDispatch();
	// Selectors
	const { isLoading, errorMsg } = useSelector((state) => state.login);
	const { checked, authenticated } = useSelector((state) => state.session);
	// State
	const [usrname, setUsrname] = useState("");

	// Refs
	const usernameRef = useRef();
	useEffect(() => usernameRef.current && usernameRef.current.focus(), []);
	// Redirect
	if (checked && authenticated) {
		return (
			<Redirect
				to={{ pathname: "/", state: { from: props.location.pathname } }}
			/>
		);
	}
	// Handlers
	function handleUsrnameChange(e) {
		if (errorMsg != null && errorMsg.usrname != null) {
			dispatch(
				setPasswordErrorMsg({
					errorMsg: { ...errorMsg, usrname: null, error: null },
				})
			);
		}
		setUsrname(e.target.value);
	}
	function handleCancel() {
		ReactGA.send({ hitType: "pageview", page: "/login" });
		scroll.scrollTo(0, { smooth: true, delay: 100, duration: 500 });
		dispatch(setPasswordErrorMsg({ errorMsg: null }));
	}
	function handleSubmit(e) {
		e.preventDefault();
		let valid = true;
		let errorMessages = { ...errorMsg };
		if (usrname.trim() === "") {
			errorMessages = {
				...errorMessages,
				usrname: "Debes escribir tu correo electrónico",
			};
			valid = false;
		}
		if (valid) {
			dispatch(
				fetchPasswordReset({ username: usrname, type: USER_TYPE.FAMILY })
			);
		} else {
			dispatch(setPasswordErrorMsg({ errorMsg: errorMessages }));
		}
	}
	let errors = null;
	if (errorMsg != null) {
		errors = (
			<div className="error-list">
				<ul>
					{renderError(errorMsg.error)}
					{renderError(errorMsg.usrname)}
				</ul>
			</div>
		);
	}
	let content;
	if (isLoading) {
		content = (
			<form>
				<div id="login-content" style={{ backgroundImage: `url(${bgImage})` }}>
					<div>
						<h1>
							ContiShop <br />
							Family &amp; Friends
						</h1>
						<p>
							La tienda en línea para amigos y familiares de los empleados de
							Continental Tire
						</p>
						<Loader msg="Enviando..." />
					</div>
				</div>
			</form>
		);
	} else {
		content = (
			<form onSubmit={handleSubmit}>
				<div id="login-content" style={{ backgroundImage: `url(${bgImage})` }}>
					<div>
						<h1>
							ContiShop <br />
							Family &amp; Friends
						</h1>
						<p>
							La tienda en línea para amigos y familiares de los empleados de
							Continental Tire
						</p>
						<div className="form-a">
							<div>
								<div>
									<label>Correo Electrónico</label>
									<input
										type="text"
										value={usrname}
										autoComplete="username"
										placeholder="Correo Electrónico"
										ref={usernameRef}
										onChange={handleUsrnameChange}
									></input>
								</div>
							</div>
						</div>
						{errors}
						<div>
							<button type="submit" className="button main">
								Restablecer Contraseña
							</button>
						</div>
						<div>
							<hr />
							<Link to={"/login"} onClick={handleCancel}>
								<button type="button" className="button">
									Cancelar
								</button>
							</Link>
						</div>
					</div>
				</div>
			</form>
		);
	}
	return (
		<div className="login">
			<div>
				<div id="logo-conti-top">
					<span></span>
				</div>
			</div>
			<div id="main-menu" className="home">
				<div id="logo-conti-top-mobile">
					<span></span>
				</div>
			</div>
			{content}
			<div id="outer-frame">
				<div id="main-container"></div>
			</div>
			<ActivationModal />
			<AlertModal />
		</div>
	);
}
